import React, {createRef, useEffect, useState} from 'react';
import { injectIntl } from 'gatsby-plugin-intl';

import GlobalStyles from '../layoutComponents/GlobalStyles';
import Header from '../layoutComponents/Header';

import Provider from "../context/ModalProvider";
import AuthProvider from "../context/AuthProvider";

import FirstScreen from '../FirstScreen';
import ModalBlock from '../Modal';
import Brand from '../PartnerBranding';
import ProductTalk from '../ProductTalk';
import Logo from '../Logo';
import Color from '../Color';
import Typography from '../Typography';
import Devices from '../Devices';
import Works from '../Works';
import Merch from '../Merch';
import Equipment from '../Equipment';
import Design from '../Design';
import DesignConstructor from '../DesignConstructor';
import Icons from '../Icons';
import SEO from '../SEO';
import Menu from '../Menu';
import { PageContainer, Main } from './App.styled';
import BrandEssencePopup from '../blockComponents/BrandEssencePopup';


function App({ intl }) {

    const characters = [
		{name:'firstScreen'},
		{name:'designSection'},
		{name:'designHierarchy'},
		{name:'designMessage'},
		{name:'designConsider'},
		{name:'designConstructorSection'},
        {name:'designComponents'},
        {name:'designLayouts'},
		{name:'productTalkSection'},
		{name:'logoSection'},
		{name:'logoMain'},
		{name:'logoAdditional'},
		{name:'logoTagline'},
		{name:'logoPartnerships'},
		{name:'logoTag'},
		{name:'logoTechnologies'},
		{name:'logoApplications'},
		{name:'logoLabel'},
        {name:'colorSection'},
        {name:'colorMain'},
        {name:'colorAdditional'},
        {name:'colorProportion'},
        {name:'typographySection'},
        {name:'typographyBlock'},
        {name:'devicesSection'},
        {name:'devicesUsage'},
        {name:'devicesProportion'},
        {name:'devicesNaming'},
        {name:'brandSection'},
        {name:'mentionBrandBlock'},
        {name:'differentiateBrandBlock'},
        {name:'worksSection'},
        {name:'postersBlock'},
        {name:'printedMaterials'},
        {name:'imagesBlock'},
        {name:'merchSection'},
        {name:'tshirtsBlock'},
        {name:'capsBlock'},
        {name:'cupsBlock'},
        {name:'bitsBlock'},
        {name:'tapeBlock'},
        {name:'bagBlock'},
        {name:'equipmentSection'},
        {name:'wallStandsBlock'},
        {name:'lstandBlock'},
        {name:'standsBlock'},
        {name:'iconsSection'},
        {name:'generalIcons'},
        {name:'appIcons'},
        {name:'cloudIcons'},
        {name:'jewellerIcons'},
        {name:'centralIcons'},
        {name:'motionIcons'},
        {name:'buttonIcons'},
        {name:'doorIcons'},
        {name:'glassIcons'},
        {name:'fireIcons'},
        {name:'leaksIcons'},
        {name:'spaceIcons'},
        {name:'keypadIcons'},
        {name:'sirenIcons'},
        {name:'automationIcons'},
        {name:'intagrationIcons'},
    ];

    const [popupBrandEssenceOpen, setPopupBrandEssenceOpen] = useState(false)
	
	const refs = characters.reduce((refsObj, character) => {
		refsObj[character.name] = createRef();
		return refsObj;
      }, {});

    
    const handleCLick = (name) => {
        refs[name].current.scrollIntoView({
            behavior: 'auto',
            block: 'start',
        });
    };

    const clickOnPopupHandler = (type) => {
        if (type) {
            setPopupBrandEssenceOpen(true)
        } else {
            setPopupBrandEssenceOpen(false)
        }
        
    }

    useEffect(() => {
        var hash = window.location.hash;
        if (hash) {
            var element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({
                    behavior: 'auto',
                    block: 'start',
                });
            }
        }
    });

    return (
        <>
            <GlobalStyles />
            <SEO title={intl.formatMessage({ id: 'title' })} />
            <Provider>
                <AuthProvider>
                    <Header handleCLick={handleCLick} />
                    <BrandEssencePopup intl={intl} popupOpen={popupBrandEssenceOpen} togglePopupScreen={() => clickOnPopupHandler(false)} />
                        <FirstScreen refs={refs} handleCLick={handleCLick} togglePopupScreen={() => clickOnPopupHandler(true)}  />
                        <PageContainer >
                            <Menu handleCLick={handleCLick} />
                            <Main>
                                <Brand
                                    refs={refs} />
                                <ProductTalk
                                    refs={refs} />
                                <Logo
                                    refs={refs} />
                                <Color
                                    refs={refs} />
                                <Typography
                                    refs={refs} />
                                <Devices
                                    refs={refs} />
                                <Works
                                    refs={refs} />
                                <Merch
                                    refs={refs} />
                                <Equipment
                                    refs={refs} />
                                <Design
                                    refs={refs} />
                                <DesignConstructor
                                    refs={refs} />
                                <Icons
                                    refs={refs} />
                            </Main>
                        </PageContainer>
                        <ModalBlock></ModalBlock>
                </AuthProvider>
            </Provider>
        </>
    )  
}

export default injectIntl(App)